/* eslint-disable @typescript-eslint/naming-convention */
import { CookieService } from 'ng2-cookies';
import { Injectable } from '@angular/core';

/**
 * The Constants Service instance.
 */
@Injectable()
export class ConstantsService {
  static cookiePath = '/';
  static urlFedAuthorize = '/authserver/oauth/authorize?';
  static urlLogin = '/authserver/login';
  static urlContext = {
    ClientSettings: './resources/api/appconfig',
    ClientSettingsk8s: '/corporate-george-auth/resources/api/clientResource',
    ResetPassword: '/api/identity/v1/rstpwd',
    UserOptions: '/api/v1/corporate-george/user/options',
    SendActivationCode: '/api/identity/v1/actcode',
    RecoverUsername: '/webapi/info/remind',
    ForceChangePassword: '/authserver/changePassword',
    GetQrCode: '/authserver/v1/login/request/qrcode/content',
    LoginOperation: '/corporate-george-auth-server/web/software-token/login-operation',
    webSocketSubscription: '/authserver/websocket',
    webSocketVerify: '/authserver/v1/login/request/check/',
    selectEntity: '/authserver/web/entity/',
    slash: '/',
  };

  publicKey: string;
  appCode: string;

  /**
   * The constructor of the Constants Service.
   *
   * @param cookieService The injected instance of the cookie service.
   */
  constructor(private cookieService: CookieService) {}

  /**
   * Get public key method.
   *
   * @returns String
   */
  getPublicKey(): string {
    return this.publicKey;
  }

  /**
   * Set public key method.
   *
   * @param key The key identifier.
   */
  setPublicKey(key: string): void {
    this.publicKey = key;
  }

  /**
   * Get app code method.
   *
   * @returns String
   */
  getAppCode(): string {
    if (this.cookieService.check('appCode')) {
      this.appCode = this.cookieService.get('appCode');
    }
    return this.appCode;
  }

  /**
   * Set app code method.
   *
   * @param appCode The app code identifier.
   */
  setAppCode(appCode: string): void {
    this.appCode = appCode;
    this.cookieService.set('appCode', appCode, null, ConstantsService.cookiePath, 'bcr.ro');
  }
}
